import { ChangeEvent, useState } from "react";

interface TextFieldProps {
  name: string;
  label: string;
  value: string | number;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  isDisabled?: boolean;
}

const TextField: React.FC<TextFieldProps> = ({
  name,
  label,
  value,
  onChange,
  isDisabled,
}) => {
  const [hasValue, setHasValue] = useState(value !== "");

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    setHasValue(inputValue !== ""); // Update hasValue state
    onChange(event); // Send the value back to the parent component
  };

  return (
    <>
      <div className="relative mt-4">
        <input
          style={{
            boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.07) inset",
          }}
          type="text"
          id={`${name}-input`}
          name={name}
          aria-label={name}
          data-testid={`${name}-input`}
          className={`peer block w-full appearance-none rounded-[8px] border-[1px] border-[#E2E2E2] bg-[#F8F8F8] px-[12px] h-[56px] pt-[18px] text-[18px] font-normal leading-[127%] text-black focus:outline-none focus:ring-0`}
          value={value}
          onChange={handleInputChange}
          disabled={isDisabled}
        />
        <label
          htmlFor={`${name}-input`}
          className={`absolute left-3 top-4 z-10 origin-[0] transform text-[16px] text-gray-500 transition-all duration-200 ${
            hasValue
              ? "peer-valid:top-5 -translate-y-4 scale-75"
              : "translate-y-0 scale-100"
          }  peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:text-[#7D8688]`}
        >
          {label}
        </label>
      </div>
    </>
  );
};

export default TextField;
